// extracted by mini-css-extract-plugin
module.exports = {"root":"_132lZ","button":"_22q5c"};